import { createHttpLink, from } from "@apollo/client/core";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { useAuth } from "~/store/auth";
import { useSettings } from "~/store/settings"; // Already import with @nuxtjs/apollo module
import { getDNSSuffix } from "~/utils/getDNSSuffix";

export default defineNuxtPlugin((nuxtApp) => {
	const runtimeConfig = useRuntimeConfig();
	const { $apollo } = useNuxtApp();
	const auth = useAuth();
	const settings = useSettings();
	const authLink = setContext(async (_, { headers }) => {
		return {
			headers: {
				Authorization: auth.token ? `Bearer ${auth.token}` : "",
				"Content-Type": "application/json",
				"X-LocationIso": settings?.config?.appSetting?.CountryCode || "TZ",
				"Accept-Language": settings.locale ?? "en-US",
				...headers,
			},
		};
	});

	const httpLink = authLink.concat(
		createHttpLink({
			uri: `${getDNSSuffix(runtimeConfig.public.graphqlUrl)}?nogeoredirect=1`,
		})
	);

	const errorLink = onError((err) => {
		nuxtApp.callHook("apollo:error", err);
	});

	// Set custom links in the apollo client (in this case, the default apollo client)
	$apollo.defaultClient.setLink(from([errorLink, httpLink]));

	nuxtApp.hook("apollo:error", (error) => {
		console.error(error);
	});
});
